// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#BottomBar span.bottombar-scale-combo > input {
    color: #595959;
}

/* Searchbox */
.SearchBox {
    color: var(--titlebar-bg-color);
}
div.searchbox-results div.searchbox-results-section-title {
    background-color: var(--titlebar-bg-color);
    color: #fff;
    padding: 0.35em 0.5em;
}
div.searchbox-results div.searchbox-results-section-title > span.icon {
    color: #fff;
}
/* The zoom/pan buttons stay in the layout (only hidden) so the rows keep their height on hover */
div.searchbox-results div.searchbox-result {
    min-height: 1.9em;
    padding: 0.15em 0.5em;
}
div.searchbox-results div.searchbox-result button.button {
    visibility: hidden;
    height: 1.5em;
    padding: 0 0.25em;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    line-height: 1;
}
div.searchbox-results div.searchbox-result:hover button.button {
    visibility: visible;
}
/* hover effect: tinted row with an accent bar on the left (inset, so the layout does not shift) */
div.searchbox-results div.searchbox-result {
    cursor: pointer;
    transition: background-color 0.12s, box-shadow 0.12s;
}
div.searchbox-results div.searchbox-result:hover {
    background-color: #e6f1f3;
    box-shadow: inset 3px 0 0 #078aa3;
}
div.searchbox-results div.searchbox-results-section-title:hover {
    background-color: #6b6f6e;
}

/* Login */
.loginscreen {
    /* qwc2 only sizes html/body while the map root is rendered, so cover the viewport explicitly */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--titlebar-bg-color);
    text-align: center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .9rem;
    letter-spacing: 2px;
}

.loginscreen button {
    background-color: var(--titlebar-bg-color);
    color: #fff;
    font-size: 1.7rem;
    padding: .7em 2em;
    border: 1px solid #fff;
    text-transform: uppercase;
    letter-spacing: 6px;
}

/* Layer Tree */
#LayerTree span.layertree-search-layer {
    margin-left: 0.5em;
    border: 1px solid transparent;
    padding: 0.25em;
}

#LayerTree span.layertree-search-layer:hover {
    border: 1px solid white;
}

#LayerTree span.layertree-search-layer-active {
    background-color: white;
    color: var(--titlebar-bg-color);
}

#LayerTree span.layertree-map-state-mgr {
    margin-left: 0.5em;
    border: 1px solid transparent;
    padding: 0.25em;
}

#LayerTree span.layertree-map-state-mgr:hover {
    border: 1px solid white;
}

#LayerTree span.layertree-map-state-mgr-active {
    background-color: white;
    color: var(--titlebar-bg-color);
}

.layertree-item-container-highlight .layertree-item-title {
    background-color: var(--titlebar-bg-color);
    color: #fff !important;
    padding: 0 3px;
}

#LayerTree span.layertree-print-legend, #LayerTree span.layertree-visible-filter, #LayerTree span.layertree-delete-legend, #LayerTree span.layertree-theme-metadata, #LayerTree span.layertree-search-layer, #LayerTree span.layertree-map-state-mgr {
    margin-left: 0.5em;
    font-size: .9rem;
}

/* Fix scale when resizing map */
.ol-scale-line {
    position: fixed !important;
}

/* Theming */
div.resizeable-window-titlebar {
    background-color: #323232;
}
div.sidebar div.sidebar-titlebar {
    background-color: #323232 !important;
}
span.resizeable-window-titlebar-control {
    font-size: .9rem;
    margin: 0.25em 0.5em;
}
div.resizeable-window {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
}
.bottombar-links a {
    color: #fff;
}

/* custom resizable windows */
.customresizeable-window-container div.resizeable-window-body {
    padding: 0;
}

/* Top bar: back/forward history next to the search field, menu label readable on the dark panel */
div.TopBar div.topbar-search-container {
    display: flex;
    align-items: center;
    max-width: calc(70ch + 6em);
}

div.TopBar div.topbar-search-container > div.SearchBox {
    flex: 1 1 auto;
    min-width: 0;
}

div.TopBar div.AppMenu .appmenu-label,
div.TopBar div.AppMenu:not(.appmenu-visible) .appmenu-icon > span.icon {
    color: var(--panel-text-color);
}

/* Bottom bar: previous look (dark input fields, scale bar without light background) */
#BottomBar div.bottombar-scalebar.ol-unselectable {
    background-color: transparent;
    backdrop-filter: none;
    padding: 0;
}

#BottomBar input,
#BottomBar select {
    color: var(--panel-text-color);
    background-color: var(--panel-bg-color);
    border: 1px solid var(--border-color);
    height: 2em;
}

#BottomBar input.bottombar-mousepos {
    border-width: 1px 0 1px 1px;
}

#BottomBar div.input-container.bottombar-scale-combo,
#BottomBar div.bottombar-scale-combo div.number-input {
    color: var(--panel-text-color);
    background-color: var(--panel-bg-color);
}

#BottomBar span.bottombar-scale-combo-prefix[role="prefix"] {
    color: var(--panel-text-color);
}

/* Identify window: result frames with more air and consistent spacing */
div.identify-body div.identify-flat-results-list {
    padding: 0.5em 0.5em 0 0.5em;
}
div.identify-body div.identify-result-frame {
    margin-bottom: 0.5em;
    background-color: #fff;
    border: 1px solid #d3d6d5;
    border-radius: 2px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
div.identify-body div.identify-result-frame:hover {
    border-color: var(--color-active);
}
div.identify-body div.identify-result-frame .identify-result-title {
    padding: 0.5em 0.65em;
    background-color: #eceeee;
    color: #323232;
    border-bottom: 1px solid #d3d6d5;
}
div.identify-body div.identify-result-frame > div.identify-result-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5em;
    padding: 0.6em 0.65em;
}
div.identify-body div.identify-result-frame > div.identify-result-container > button.button {
    margin: 0;
    padding: 0.4em 1em;
}

/* Search field in the top bar: no frame, subtle focus ring, plain clear icon */
div.TopBar div.searchbox-field.input-container {
    border: 0;
}
div.TopBar div.searchbox-field.input-container:focus-within {
    outline: none;
}
div.searchbox-field > span.searchbox-clear {
    font-size: 0.7em;
    padding: 0 0.9em;
    color: #8a8f8e;
    cursor: pointer;
}
div.searchbox-field > span.searchbox-clear:hover {
    color: #323232;
}

/* Map copyright: discreet light background instead of the dark panel color */
.plugins-container div.MapCopyright {
    background-color: rgba(255, 255, 255, 0.5);
    color: #323232;
}
.plugins-container div.MapCopyright span:not(:first-child) {
    border-left-color: #323232;
}
`, "",{"version":3,"sources":["webpack://./js/style/CustomApp.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,+BAA+B;AACnC;AACA;IACI,0CAA0C;IAC1C,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA,iGAAiG;AACjG;IACI,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA,kGAAkG;AAClG;IACI,eAAe;IACf,oDAAoD;AACxD;AACA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,yBAAyB;AAC7B;;AAEA,UAAU;AACV;IACI,+FAA+F;IAC/F,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;IAC1C,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,0BAA0B;AAC9B;;AAEA,YAAY;AACZ;IACI,yBAAyB;AAC7B;AACA;IACI,oCAAoC;AACxC;AACA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,WAAW;AACf;;AAEA,6BAA6B;AAC7B;IACI,UAAU;AACd;;AAEA,kGAAkG;AAClG;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA,sFAAsF;AACtF;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,UAAU;AACd;;AAEA;;IAEI,8BAA8B;IAC9B,uCAAuC;IACvC,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA,wEAAwE;AACxE;IACI,4BAA4B;AAChC;AACA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;AAC7C;AACA;IACI,iCAAiC;AACrC;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA,+EAA+E;AAC/E;IACI,SAAS;AACb;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,0CAA0C;IAC1C,cAAc;AAClB;AACA;IACI,0BAA0B;AAC9B","sourcesContent":["#BottomBar span.bottombar-scale-combo > input {\n    color: #595959;\n}\n\n/* Searchbox */\n.SearchBox {\n    color: var(--titlebar-bg-color);\n}\ndiv.searchbox-results div.searchbox-results-section-title {\n    background-color: var(--titlebar-bg-color);\n    color: #fff;\n    padding: 0.35em 0.5em;\n}\ndiv.searchbox-results div.searchbox-results-section-title > span.icon {\n    color: #fff;\n}\n/* The zoom/pan buttons stay in the layout (only hidden) so the rows keep their height on hover */\ndiv.searchbox-results div.searchbox-result {\n    min-height: 1.9em;\n    padding: 0.15em 0.5em;\n}\ndiv.searchbox-results div.searchbox-result button.button {\n    visibility: hidden;\n    height: 1.5em;\n    padding: 0 0.25em;\n    border: 0;\n    background-color: transparent;\n    cursor: pointer;\n    line-height: 1;\n}\ndiv.searchbox-results div.searchbox-result:hover button.button {\n    visibility: visible;\n}\n/* hover effect: tinted row with an accent bar on the left (inset, so the layout does not shift) */\ndiv.searchbox-results div.searchbox-result {\n    cursor: pointer;\n    transition: background-color 0.12s, box-shadow 0.12s;\n}\ndiv.searchbox-results div.searchbox-result:hover {\n    background-color: #e6f1f3;\n    box-shadow: inset 3px 0 0 #078aa3;\n}\ndiv.searchbox-results div.searchbox-results-section-title:hover {\n    background-color: #6b6f6e;\n}\n\n/* Login */\n.loginscreen {\n    /* qwc2 only sizes html/body while the map root is rendered, so cover the viewport explicitly */\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: var(--titlebar-bg-color);\n    text-align: center;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: .9rem;\n    letter-spacing: 2px;\n}\n\n.loginscreen button {\n    background-color: var(--titlebar-bg-color);\n    color: #fff;\n    font-size: 1.7rem;\n    padding: .7em 2em;\n    border: 1px solid #fff;\n    text-transform: uppercase;\n    letter-spacing: 6px;\n}\n\n/* Layer Tree */\n#LayerTree span.layertree-search-layer {\n    margin-left: 0.5em;\n    border: 1px solid transparent;\n    padding: 0.25em;\n}\n\n#LayerTree span.layertree-search-layer:hover {\n    border: 1px solid white;\n}\n\n#LayerTree span.layertree-search-layer-active {\n    background-color: white;\n    color: var(--titlebar-bg-color);\n}\n\n#LayerTree span.layertree-map-state-mgr {\n    margin-left: 0.5em;\n    border: 1px solid transparent;\n    padding: 0.25em;\n}\n\n#LayerTree span.layertree-map-state-mgr:hover {\n    border: 1px solid white;\n}\n\n#LayerTree span.layertree-map-state-mgr-active {\n    background-color: white;\n    color: var(--titlebar-bg-color);\n}\n\n.layertree-item-container-highlight .layertree-item-title {\n    background-color: var(--titlebar-bg-color);\n    color: #fff !important;\n    padding: 0 3px;\n}\n\n#LayerTree span.layertree-print-legend, #LayerTree span.layertree-visible-filter, #LayerTree span.layertree-delete-legend, #LayerTree span.layertree-theme-metadata, #LayerTree span.layertree-search-layer, #LayerTree span.layertree-map-state-mgr {\n    margin-left: 0.5em;\n    font-size: .9rem;\n}\n\n/* Fix scale when resizing map */\n.ol-scale-line {\n    position: fixed !important;\n}\n\n/* Theming */\ndiv.resizeable-window-titlebar {\n    background-color: #323232;\n}\ndiv.sidebar div.sidebar-titlebar {\n    background-color: #323232 !important;\n}\nspan.resizeable-window-titlebar-control {\n    font-size: .9rem;\n    margin: 0.25em 0.5em;\n}\ndiv.resizeable-window {\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);\n}\n.bottombar-links a {\n    color: #fff;\n}\n\n/* custom resizable windows */\n.customresizeable-window-container div.resizeable-window-body {\n    padding: 0;\n}\n\n/* Top bar: back/forward history next to the search field, menu label readable on the dark panel */\ndiv.TopBar div.topbar-search-container {\n    display: flex;\n    align-items: center;\n    max-width: calc(70ch + 6em);\n}\n\ndiv.TopBar div.topbar-search-container > div.SearchBox {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\ndiv.TopBar div.AppMenu .appmenu-label,\ndiv.TopBar div.AppMenu:not(.appmenu-visible) .appmenu-icon > span.icon {\n    color: var(--panel-text-color);\n}\n\n/* Bottom bar: previous look (dark input fields, scale bar without light background) */\n#BottomBar div.bottombar-scalebar.ol-unselectable {\n    background-color: transparent;\n    backdrop-filter: none;\n    padding: 0;\n}\n\n#BottomBar input,\n#BottomBar select {\n    color: var(--panel-text-color);\n    background-color: var(--panel-bg-color);\n    border: 1px solid var(--border-color);\n    height: 2em;\n}\n\n#BottomBar input.bottombar-mousepos {\n    border-width: 1px 0 1px 1px;\n}\n\n#BottomBar div.input-container.bottombar-scale-combo,\n#BottomBar div.bottombar-scale-combo div.number-input {\n    color: var(--panel-text-color);\n    background-color: var(--panel-bg-color);\n}\n\n#BottomBar span.bottombar-scale-combo-prefix[role=\"prefix\"] {\n    color: var(--panel-text-color);\n}\n\n/* Identify window: result frames with more air and consistent spacing */\ndiv.identify-body div.identify-flat-results-list {\n    padding: 0.5em 0.5em 0 0.5em;\n}\ndiv.identify-body div.identify-result-frame {\n    margin-bottom: 0.5em;\n    background-color: #fff;\n    border: 1px solid #d3d6d5;\n    border-radius: 2px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\ndiv.identify-body div.identify-result-frame:hover {\n    border-color: var(--color-active);\n}\ndiv.identify-body div.identify-result-frame .identify-result-title {\n    padding: 0.5em 0.65em;\n    background-color: #eceeee;\n    color: #323232;\n    border-bottom: 1px solid #d3d6d5;\n}\ndiv.identify-body div.identify-result-frame > div.identify-result-container {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.5em;\n    padding: 0.6em 0.65em;\n}\ndiv.identify-body div.identify-result-frame > div.identify-result-container > button.button {\n    margin: 0;\n    padding: 0.4em 1em;\n}\n\n/* Search field in the top bar: no frame, subtle focus ring, plain clear icon */\ndiv.TopBar div.searchbox-field.input-container {\n    border: 0;\n}\ndiv.TopBar div.searchbox-field.input-container:focus-within {\n    outline: none;\n}\ndiv.searchbox-field > span.searchbox-clear {\n    font-size: 0.7em;\n    padding: 0 0.9em;\n    color: #8a8f8e;\n    cursor: pointer;\n}\ndiv.searchbox-field > span.searchbox-clear:hover {\n    color: #323232;\n}\n\n/* Map copyright: discreet light background instead of the dark panel color */\n.plugins-container div.MapCopyright {\n    background-color: rgba(255, 255, 255, 0.5);\n    color: #323232;\n}\n.plugins-container div.MapCopyright span:not(:first-child) {\n    border-left-color: #323232;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
